export enum StyleOverrideEnum {
  YET_TO_BE_OVERRIDEN = 'yet-to-be-overriden',
}
